module.exports = __webpack_public_path__ + "img/defaultVImg.84c54b86.jpeg";